import React from "react";
import UnitsApi from "../../../api/UnitsApi";
import DocumentsApi from "../../../api/DocumentsApi";
import DocumentTypesApi from "../../../api/DocumentTypesApi";

type ContextType = {
  unit: any,
  documentTypes: any[],
  pdfFile: any,
  refresh: any,
  unitDocument: any,
  documentType: any
}

export const defaultContext = {
  unit: null,
  documentTypes: [],
  pdfFile: null,
  refresh: null,
  unitDocument: {
    fileContentType: '',
    mediaURL: '',
    documentType: {
      id: ''
    }
  },
  documentType: {
    name: ''
  }
}

export default React.createContext<ContextType>({
  unit: null,
  documentTypes: [],
  pdfFile: null,
  refresh: null,
  unitDocument: {
    fileContentType: '',
    mediaURL: '',
    documentType: {
      id: ''
    }
  },
  documentType: {
    name: ''
  }
})

export const getPopulatedContext = (domain: string, documentId: string): Promise<ContextType> => {
  return Promise.all([
    UnitsApi.get(domain),
    DocumentTypesApi.filter()
  ]).then((responses: any[]) => {
    const unit = responses[0].data
    const documentTypes = responses[1].data
    const unitDocument = unit.documents.find((it: any) => it.id === documentId)
    const documentType = documentTypes.find((it: any) => it.id === unitDocument.documentType.id)
    if (unitDocument.fileContentType === "application/pdf") {
      return DocumentsApi.getFile(unitDocument.mediaURL)
      .then((pdfFile: any) => {
        return Promise.resolve({
          unit,
          documentTypes,
          pdfFile,
          refresh: null,
          unitDocument,
          documentType
        })
      })
    } else return Promise.resolve({
      unit,
      documentTypes,
      pdfFile: null,
      refresh: null,
      unitDocument,
      documentType
    })
  })
}